export default __webpack_public_path__ + "static/media/thumb10_recipe@2x.0126c754.png";